var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wl-dialog-form",
    {
      ref: "wl-dialog-form",
      staticClass: "wl-dialog-row-detail",
      attrs: {
        open: _vm.show,
        width: _vm.rowDialogWith,
        btns: _vm.btns,
        grid: _vm.grid,
        title: _vm.title,
        model: _vm.form,
        rules: _vm.rules,
        "form-options": { "label-width": _vm.rowLabelWidth },
        loading: _vm.loading,
        disabled: _vm.disabled,
      },
      on: {
        "update:open": function ($event) {
          _vm.show = $event
        },
        getDatasSuccess: _vm.getDatasSuccess,
        getDatasError: _vm.getDatasError,
        onOk: _vm.onOk,
        openDialog: _vm.openDialog,
        closeDialog: _vm.closeDialog,
      },
    },
    _vm._l(_vm.rowItem, function (tabFields, index) {
      return _c(
        "div",
        {
          key: index,
          attrs: { slot: "tabs-top", label: tabFields.tab },
          slot: "tabs-top",
        },
        [
          _c("wl-form-control", {
            attrs: {
              form: _vm.form,
              grid: _vm.grid,
              "form-items": tabFields.fields,
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }